import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon ThumbsDownIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const ThumbsDownIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <path
        d="M19.503 15.082C18.3713 15.082 17.506 14.1779 17.506 12.9957L17.506 4.09396C17.506 2.9117 18.3713 2.00762 19.503 2.00762C20.6346 2.00762 21.5 2.9117 21.5 4.09396L21.5 12.9957C21.5 14.1779 20.6346 15.082 19.503 15.082Z"
        stroke="black"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M19.4746 2L7.70287 2C6.08161 2 4.67182 3.05866 4.46035 4.54078L2.62763 11.6252C1.99322 14.2365 3.82595 15.154 5.87014 15.154L9.38052 15.154C9.59199 15.154 9.73296 15.3658 9.65543 15.5634C8.22449 19.3675 9.59199 22 11.0159 22C12.4398 22 12.2847 20.0944 13.1306 18.1888C14.5403 15.0834 16.3731 15.0834 16.796 15.0834L19.4746 15.0834"
        stroke="black"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
    </Icon>
  )
}
export default ThumbsDownIcon
